/* BUILDER A’s route registrations — the ONLY shared-tree file Builder A edits
   besides its own folders. Add <Route> elements to this array; the app mounts
   them inside the shell. Screens live in src/routes/{parcours,destinations,
   messages,equipe}/. Scope: WF-06 · WF-08 · WF-11 · WF-12.
   One explicit route per frame (ruling 30/08) — no splat, so every frame has
   its own URL and therefore its own evidence screenshot. */
import { Route } from 'react-router-dom'
import type { ReactElement } from 'react'
import Destinations from '@/routes/destinations/Destinations'
import Ajouter from '@/routes/destinations/Ajouter'
import Regles from '@/routes/destinations/Regles'
import Google from '@/routes/destinations/Google'
import Fiche from '@/routes/destinations/Fiche'
import Suspendre from '@/routes/destinations/Suspendre'
import Desactivee from '@/routes/destinations/Desactivee'
import Lien from '@/routes/destinations/Lien'
import Facebook from '@/routes/destinations/Facebook'
import Confirmations from '@/routes/destinations/Confirmations'
import Messages from '@/routes/messages/Messages'
import Classes from '@/routes/messages/Classes'
import Modeles from '@/routes/messages/Modeles'
import Studio from '@/routes/messages/Studio'
import Apercu from '@/routes/messages/Apercu'
import Preferences from '@/routes/messages/Preferences'
import Journal from '@/routes/messages/Journal'
import Avis from '@/routes/messages/Avis'
import Voix from '@/routes/messages/Voix'
import Brouillon from '@/routes/messages/Brouillon'
import Etats from '@/routes/messages/Etats'
import RevenezJouer from '@/routes/messages/RevenezJouer'
import Defi from '@/routes/equipe/Defi'
import Nouveau from '@/routes/equipe/Nouveau'
import Moi from '@/routes/equipe/Moi'
import Validation from '@/routes/equipe/Validation'
import Cloture from '@/routes/equipe/Cloture'
import Parcours from '@/routes/parcours/Parcours'
import Etape from '@/routes/parcours/Etape'
import Compte from '@/routes/parcours/Compte'
import Exposition from '@/routes/parcours/Exposition'
import Apres5 from '@/routes/parcours/Apres5'
import Automatisations from '@/routes/parcours/Automatisations'
import Rythme from '@/routes/parcours/Rythme'
import Migration from '@/routes/parcours/Migration'
import Retention from '@/routes/parcours/Retention'
import Variante from '@/routes/parcours/Variante'
import Quiz from '@/routes/parcours/Quiz'
import Question from '@/routes/parcours/Question'

export const routesA: ReactElement[] = [
  /* ---------- WF-08 · Destinations & Google (DS-01…DS-11) ---------- */
  <Route key="ds-01" path="/destinations" element={<Destinations />} />,
  <Route key="ds-02" path="/destinations/ajouter" element={<Ajouter />} />,
  <Route key="ds-03" path="/destinations/regles" element={<Regles />} />,
  <Route key="ds-04" path="/destinations/google" element={<Google />} />,
  <Route key="ds-05" path="/destinations/fiche" element={<Fiche />} />,
  <Route key="ds-06" path="/destinations/suspendre" element={<Suspendre />} />,
  <Route key="ds-07" path="/destinations/desactivee" element={<Desactivee />} />,
  <Route key="ds-08" path="/destinations/lien" element={<Lien />} />,
  <Route key="ds-09" path="/destinations/facebook" element={<Facebook />} />,
  <Route key="ds-10" path="/destinations/confirmations" element={<Confirmations />} />,

  /* ---------- WF-11 · Email, messages & notifications (EM-01…EM-10) ---------- */
  <Route key="em-07" path="/messages" element={<Messages />} />,
  <Route key="em-01" path="/messages/classes" element={<Classes />} />,
  <Route key="em-02" path="/messages/modeles" element={<Modeles />} />,
  <Route key="em-03" path="/messages/modeles/studio" element={<Studio />} />,
  <Route key="em-04" path="/messages/apercu/cadeau" element={<Apercu id="cadeau" />} />,
  <Route key="em-05" path="/messages/apercu/avis" element={<Apercu id="avis" />} />,
  <Route key="em-06" path="/messages/apercu/rappel" element={<Apercu id="rappel-retour" />} />,
  <Route key="em-08" path="/messages/preferences" element={<Preferences />} />,
  <Route key="em-09" path="/messages/journal" element={<Journal />} />,
  /* D-69 ② (batch 14) — the « Retour » class has one message and its own screen */
  <Route key="em-12" path="/messages/revenez-jouer" element={<RevenezJouer />} />,

  /* ---------- WF-12 · AI responses & Défi d’équipe (AI-01…04 · TC-01…05) ---------- */
  <Route key="ai-01" path="/messages/avis" element={<Avis />} />,
  <Route key="ai-02" path="/messages/avis/voix" element={<Voix />} />,
  <Route key="ai-03" path="/messages/avis/brouillon" element={<Brouillon />} />,
  <Route key="ai-04" path="/messages/avis/etats" element={<Etats />} />,
  <Route key="tc-02" path="/equipe/defi" element={<Defi />} />,
  <Route key="tc-01" path="/equipe/defi/nouveau" element={<Nouveau />} />,
  <Route key="tc-03" path="/equipe/defi/moi" element={<Moi />} />,
  <Route key="tc-04" path="/equipe/defi/validation" element={<Validation />} />,
  <Route key="tc-05" path="/equipe/defi/cloture" element={<Cloture />} />,

  /* ---------- WF-06 · Return Journeys & Experiences (RJ-01…RJ-12) ---------- */
  <Route key="rj-01" path="/campagnes/parcours" element={<Parcours />} />,
  <Route key="rj-02" path="/campagnes/parcours/etape" element={<Etape />} />,
  <Route key="rj-03" path="/campagnes/parcours/compte-a-rebours" element={<Compte />} />,
  <Route key="rj-04" path="/campagnes/parcours/exposition" element={<Exposition />} />,
  <Route key="rj-05" path="/campagnes/parcours/apres-etape-5" element={<Apres5 />} />,
  <Route key="rj-06" path="/campagnes/parcours/automatisations" element={<Automatisations />} />,
  <Route key="rj-07" path="/campagnes/parcours/rythme" element={<Rythme />} />,
  <Route key="rj-08" path="/campagnes/parcours/migration" element={<Migration />} />,
  <Route key="rj-09" path="/campagnes/parcours/retention" element={<Retention />} />,
  <Route key="rj-10" path="/campagnes/parcours/variante" element={<Variante />} />,
  <Route key="rj-11" path="/campagnes/parcours/quiz" element={<Quiz />} />,
  <Route key="rj-12" path="/campagnes/parcours/quiz/question" element={<Question />} />,
]
